import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=06b9817e&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=06b9817e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9817e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b9817e')) {
      api.createRecord('06b9817e', component.options)
    } else {
      api.reload('06b9817e', component.options)
    }
    module.hot.accept("./Service.vue?vue&type=template&id=06b9817e&scoped=true&", function () {
      api.rerender('06b9817e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Service.vue"
export default component.exports